import React from 'react'
import { Responsive, Button, Icon, Container } from 'semantic-ui-react'

import useWindowWidth from 'lib/hooks/useWindowWidth'
import useIsMounted from 'lib/hooks/useIsMounted'
import NavLink from 'lib/components/NavLink'

const CategorySelector = ({}) => {
  const width = useWindowWidth()
  const isMobile = Responsive.onlyMobile.maxWidth > width
  const mounted = useIsMounted()

  return (
    <Responsive
      as={Container}
      fireOnMount
      textAlign="center"
      css={{
        marginBottom: '1rem',
      }}
      key={mounted ? 'ssr' : 'cli'}
    >
      <Button.Group vertical={isMobile} fluid={isMobile}>
        <NavLink href="/recalls" passHref>
          <Button as="a">All</Button>
        </NavLink>
        <NavLink href="/recalls/[category]" as="/recalls/4" passHref>
          <Button as="a">
            <Icon name="cart" />
            Consumer Products
          </Button>
        </NavLink>
        <NavLink href="/recalls/[category]" as="/recalls/2" passHref>
          <Button as="a">
            <Icon name="car" />
            Vehicles
          </Button>
        </NavLink>
        <NavLink href="/recalls/[category]" as="/recalls/1" passHref>
          <Button as="a">
            <Icon name="food" />
            Food
          </Button>
        </NavLink>
        <NavLink href="/recalls/[category]" as="/recalls/3" passHref>
          <Button as="a">
            <Icon name="medkit" />
            Health Products
          </Button>
        </NavLink>
      </Button.Group>
    </Responsive>
  )
}

export default CategorySelector
